// permissionMatrixService.ts
// API phân quyền chức năng (ma trận). Spec: docs/for-backup/0001-ma-tran-phan-quyen-chuc-nang.md
import axiosInstance from '@/services/axiosInstance'
import { PermissionCell } from '@/types/PermissionMatrix'

// Lấy quyền của chính user đang đăng nhập (FE dùng để ẩn/hiện menu + nút thao tác)
// skipGlobalError: tránh bắn toast khi BE chưa sẵn sàng (sẽ fallback Permission.ts tĩnh)
export const apiGetMyPermissions = async () => {
  const response = await axiosInstance.get(`/api/v1/permissions/me`, { skipGlobalError: true })
  return response.data
}

// Lấy toàn bộ ma trận (cột role + dòng resource + ô) cho màn cấu hình (chỉ BOD)
export const apiGetPermissionMatrix = async () => {
  const response = await axiosInstance.get(`/api/v1/permissions/matrix`)
  return response.data
}

// Cập nhật ma trận — gửi lên tất cả ô (chỉ BOD)
export const apiUpdatePermissionMatrix = async (cells: PermissionCell[]) => {
  const response = await axiosInstance.put(
    `/api/v1/permissions/matrix`,
    { cells },
    { headers: { 'Content-Type': 'application/json' } },
  )
  return response.data
}
